const formatFilter = (filter, relations) => {
  let aux = {}
  Object.keys(relations).forEach(item => {
    aux = { ...aux, [item]: filter[relations[item]] }
  })
  return aux
}

export default formatFilter
